import { Language } from 'app/i18n/translationModels';
import { IWebChatModule } from 'app/services/ostroAdapter';

export function getLanguageCodefromUrl(): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  const languageCode = urlParams.get('tailor-lang');

  if (languageCode) {
    urlParams.delete('tailor-lang');
    const newQueryString = urlParams.toString();
    window.history.replaceState({}, '', window.location.pathname + (newQueryString ? `?${newQueryString}` : ''));
  }

  return languageCode;
}

export function findFirstMatchingLanguage(codes: string[] | null): Language | null {
  const enumValues = Object.values(Language);

  const foundCode = codes?.find((code) => enumValues.includes(code as Language));

  return foundCode ? (foundCode as Language) : null;
}

export const getLanguageCodeByCondUuid = (langModules: IWebChatModule[], condition_uuid: string): string | null => {
  const module = langModules.find((lang) => lang.condition_uuid === condition_uuid);

  return module ? findFirstMatchingLanguage(module.language_codes) : null;
};
